var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMute = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M16 5a7 7 0 0 0-7 7c0 3.353-.717 5.435-1.378 6.646a6 6 0 0 1-.88 1.244 3 3 0 0 1-.305.284l-.003.002A1 1 0 0 0 7 22h18a1 1 0 0 0 .566-1.824l-.002-.002-.053-.042a3 3 0 0 1-.254-.242 6 6 0 0 1-.88-1.244C23.718 17.435 23 15.353 23 12a7 7 0 0 0-7-7m6.85 15H9.15q.113-.187.228-.396C10.218 18.065 11 15.647 11 12a5 5 0 0 1 10 0c0 3.647.783 6.065 1.622 7.604q.114.21.229.396",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.135 24.498a1 1 0 1 0-1.73 1.004 3 3 0 0 0 5.19 0 1 1 0 0 0-1.73-1.004 1 1 0 0 1-1.73 0"
})));
export default SvgMute;